"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthFailureReasonSchema = exports.AuthFailureReasonEnum = void 0;
const zod_1 = require("zod");
var AuthFailureReasonEnum;
(function (AuthFailureReasonEnum) {
    AuthFailureReasonEnum["Blocked"] = "BLOCKED";
    AuthFailureReasonEnum["ExpiredTrial"] = "EXPIRED_TRIAL";
    AuthFailureReasonEnum["ExpiredSubscription"] = "EXPIRED_SUBSCRIPTION";
    AuthFailureReasonEnum["ForceUpgrade"] = "FORCE_UPGRADE";
    AuthFailureReasonEnum["MissingEmail"] = "MISSING_EMAIL";
    AuthFailureReasonEnum["UnverifiedEmail"] = "UNVERIFIED_EMAIL";
})(AuthFailureReasonEnum = exports.AuthFailureReasonEnum || (exports.AuthFailureReasonEnum = {}));
exports.AuthFailureReasonSchema = zod_1.z.nativeEnum(AuthFailureReasonEnum);
//# sourceMappingURL=auth_failure.js.map